<template>
	<ui-modal-template>
		<template v-slot:title>
			<span>cropspot+ Abo bestellen </span>
		</template>
		<template v-slot:content>
			<div class="px-6 py-6">
				<div class="px-6">

					<div v-if="trialAvailable">
						<p class="font-semibold py-2">Testen Sie cropspot+ für {{ wizardDeps.subscription.trialDays }} Tage und sichern Sie sich alle Inhalte und Funktionen im Abonnement.</p>
						<p class="py-2">Wenn Sie das cropspot+ Abo nicht mindestens 24 Stunden vor Ende des {{ wizardDeps.subscription.trialDays }}-tägigen Testzeitraums kündigen, geht es automatisch in das kostenpflichtige Jahresabonnement über. Der Preis für das cropspot+ Abo beträgt {{ price }} € inkl. MwSt. pro Jahr und wird nach Ende des Testzeitraums fällig.</p>
					</div>
					<div v-else>
						<p class="font-semibold py-2">Sichern Sie sich alle Inhalte und Funktionen im Abonnement.</p>
						<p class="py-2">Der Preis für das cropspot+ Abo beträgt 178,50 € inkl. MwSt. pro Jahr und wird zu Beginn des Abonnementzeitraums fällig. Sie können das Jahresabonnement jederzeit mit einer Frist von {{ wizardDeps.subscription.noticePeriodDays }} Tagen zum Ende der Laufzeit kündigen.</p>
					</div>

					<!-- Addresse -->
					<div v-if="selectedPaymentMethod?.address_required">

						<p class="my-6 font-bold">Rechnungsanschrift</p>

						<ui-input-group
							class="basis-full md:basis-1/3 my-2"
							v-model="formData.address.company_name"
							field="address.company_name"
							:form="formData"
							label="Firma"
							:required="true"
							:labelIsBold="true"
						></ui-input-group>

						<div class="flex">
							<ui-input-group
								class="basis-full md:basis-2/3 my-2 pr-2"
								v-model="formData.address.street"
								field="address.street"
								:form="formData"
								label="Straße"
								:required="true"
								:labelIsBold="true"
							></ui-input-group>

							<ui-input-group
								class="basis-full md:basis-1/3 my-2 pl-2"
								v-model="formData.address.house_number"
								field="address.house_number"
								:form="formData"
								label="Hausnummer"
								:required="true"
								:labelIsBold="true"
							></ui-input-group>
						</div>

						<div class="flex">
							<ui-input-group
								class="basis-full md:basis-1/3 my-2 pr-2"
								v-model="formData.address.postal_code"
								field="address.postal_code"
								:form="formData"
								label="PLZ"
								:required="true"
								:labelIsBold="true"
							></ui-input-group>

							<ui-input-group
								class="basis-full md:basis-1/3 my-2 px-2"
								v-model="formData.address.city"
								field="address.city"
								:form="formData"
								label="Ort"
								:required="true"
								:labelIsBold="true"
							></ui-input-group>

							<ui-select-group
								class="basis-full md:basis-1/3 my-2 pl-2"
								v-model="formData.address.country"
								type="select"
								field="address.country"
								label="Country"
								:options="countryOptions"
								:form="formData"
								:required="true"
								:labelIsBold="true"
							></ui-select-group>
						</div>

						<ui-input-group
							class="basis-full md:basis-1/3 my-6"
							v-model="formData.address.email"
							field="address.email"
							:form="formData"
							label="Rechnungs-Email"
							:required="true"
							:labelIsBold="true"
						></ui-input-group>
					</div>
				</div>
			</div>

			<hr class="h-0.5 bg-gray-200 text-gray-200" />

			<div class="px-6 py-3">
				<div class="px-6">
					<p class="my-6 font-bold">Wie möchten Sie zahlen?</p>

					<div class="flex mt-1 mb-4 text-lg">
						<div class="flex px-2"
								 v-for="(paymentMethod, index) in wizardDeps.paymentMethods"
						>
							<ui-radio-group
								class="mr-2"
								v-model="formData.payment_method_code"
								:radioValue="paymentMethod.code"
								:key="formData.payment_method_code + paymentMethod.id"
								name="payment_method_code"
								v-on:change="paymentMethodUpdate"
							>
								{{ __(paymentMethod.label) }}
							</ui-radio-group>

							<div class="flex items-center basis-1/2">
								<img class="w-full min-w-6 max-h-10" :src="paymentMethod.image" />
							</div>

						</div>
					</div>

					<div class="my-4"
							 v-if="formData.payment_method_code == 'directdebit'"
							 >
							<ui-input-group
								class="basis-full md:basis-1/3 my-2"
								v-model="formData.bank_account.owner"
								field="bank_account.owner"
								:form="formData"
								label="Name des Kontoinhabers"
								:required="true"
							></ui-input-group>

						<ui-input-group
							class="basis-full md:basis-1/3 my-2"
							v-model="formData.bank_account.iban"
							field="bank_account.iban"
							:form="formData"
							label="IBAN"
							:required="true"
						></ui-input-group>

						<p class="mt-4 font-semibold">Einwilligungserklärung</p>
						<p>Durch das Hinzufügen Ihres Bankkontos ermächtigen Sie die cropspot GmbH, Anweisungen an Ihre Bank zu senden, um Ihr Konto zu belasten. Sie ermächtigen Ihre Bank außerdem, Ihr Konto gemäß diesen Anwweisungen zu belasten.</p>
					</div>
				</div>
			</div>
			<div class="bg-gray-100 p-6">
				<div class="flex justify-end px-6">
					<ui-button
						:disabled="loading"
						v-on:click="submitForm()"
						label="Weiter"
					/>
				</div>
			</div>
		</template>
		<!-- devide -->
	</ui-modal-template>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import {formatLocalizedNumber} from "../../cropOptions";

export default {
	props: {
		formData: Object,
		wizardDeps: Object,
		stepDeps: Object,
		loading: Boolean
	},
	data() {
		return {
			countryOptions: this.$cropOptions.countryOptions,
			acl: this.$inertia.page.props.acl,
		}
	},
	computed: {
		trialAvailable() {
			return this.acl.subscriptions_trial ?? false
		},
		price: function() {
			return formatLocalizedNumber(this.wizardDeps.subscription.netPrice * (1 + this.wizardDeps.subscription.tax));
		},
		selectedPaymentMethod(){
			return this.wizardDeps.paymentMethods.find((item) => item.code === this.formData.payment_method_code) ?? null
		},
	},
	methods: {
		formatLocalizedNumber,
		paymentMethodUpdate(value){
			this.formData.payment_method_code = value;
		},
		async submitForm() {

			if(this.loading){
				return;
			}

			const params = {};
			if (this.stepDeps.step) {
				params["step"] = this.stepDeps.step;
			}

			let promise = new Promise((resolve, reject) => {
				const response = axios.patch(
					this.$route("premium.store", params),
					this.formData
				);

				resolve(response);
				reject(response);
			});

			promise.then(
				(result) => this.onSuccess(result),
				(error) => this.onError(error)
			);
		},
		onSuccess(result) {
			this.$bus.$emit("wizard:next")
		},
		onError(error) {
			const errors = error.response.data.errors;
			this.$bus.$emit("form:invalid", errors);
		},
	},
};
</script>
